import { RootState } from '~/stores';

export const isolateUiState = (s: RootState) => s.ui;
export const isolateIsMenuOpen: (s: RootState) => boolean = s => isolateUiState(s).isMenuOpen;
export const isolateIsFullScreen: (s: RootState) => boolean = s => isolateUiState(s).isFullScreen;
export const isolateVersion: (s: RootState) => string = s => isolateUiState(s).version || 'unknown';

